import React, { FunctionComponent, useEffect, useState } from 'react';
import { cloneDeep, isEmpty, get } from 'lodash';

import './Appointment.scss';
import { BusinessHoursType } from './AppointmentList';
import { HoursSelection } from './HoursSelection';

interface Props {
  formData: any;
  onChange: Function;
}

const defaultDayConfig = {
  enabled: false,
  start: 10,
  end: 19,
};

const DAYS = [
  'sunday',
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
];

const defaultConfig = {
  days: {
    [DAYS[0]]: cloneDeep(defaultDayConfig),
    [DAYS[1]]: cloneDeep(defaultDayConfig),
    [DAYS[2]]: cloneDeep(defaultDayConfig),
    [DAYS[3]]: cloneDeep(defaultDayConfig),
    [DAYS[4]]: cloneDeep(defaultDayConfig),
    [DAYS[5]]: cloneDeep(defaultDayConfig),
    [DAYS[6]]: cloneDeep(defaultDayConfig),
  },
};

export const BusinessHours: FunctionComponent<Props> = ({
  formData,
  onChange,
}) => {
  const [businessHoursConfig, setBusinessHoursConfig] = useState({} as any);

  useEffect(() => {
    let businessHoursConfigCopy = cloneDeep(formData);
    if (!businessHoursConfigCopy) {
      businessHoursConfigCopy = cloneDeep(defaultConfig);
    }
    setBusinessHoursConfig(businessHoursConfigCopy);
  }, [formData]);

  return (
    <div className="business-hours-input-group config-group col-md-5">
      <h3 key="label" className="control-label">
        Business Hours
      </h3>
      {!isEmpty(businessHoursConfig) && (
        <div className="input-container">
          <span className="info">
            Enter the sales hours the dealership is open to customers.
          </span>
          <div className={`${BusinessHoursType.BusinessHour}-hours-section`}>
            {DAYS.map((day) => {
              const enabled =
                get(businessHoursConfig, `days.${day}.enabled`) || false;
              return (
                <HoursSelection
                  key={`${BusinessHoursType.BusinessHour}-${day}`}
                  enabled={enabled}
                  day={day}
                  scheduleConfig={businessHoursConfig}
                  onChange={onChange}
                  setScheduleConfig={setBusinessHoursConfig}
                  defaultDayConfig={defaultDayConfig}
                  scheduleType={BusinessHoursType.BusinessHour}
                />
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default BusinessHours;
